import { motion } from 'framer-motion';
import shared from '../../styles/shared.module.css';
import styles from './TestimonialsSection.module.css';
import { GOOGLE_REVIEW_URL } from '../../constants';
import { fadeUp, staggerContainer, cardVariant } from '../../animations';

import headingReviews from '../../assets/figma/page13/heading-reviews.png';

const reviews = [
  {
    name: 'Joelma Schmidt Alves',
    text: 'Excelente profissional, trabalho impecável, entende exatamente oque você precisa, não precisei mexer nenhuma vez no projeto, pois ela entregou além do que eu esperava, recomendo de olhos fechados ❤👏🏻👏🏻👏🏻👏🏻',
  },
  {
    name: 'Douglas Brandão',
    text: 'Projeto realizado com muito carinho e muita atenção!!! Ficamos bastantes satisfeitos com o resultado e com a disposição pra ajudar !!! Vale muito a pena !!',
  },
  {
    name: 'Rosiane Ventura Zanin',
    text: 'Ficamos encantados com o trabalho da Cris, os ambientes ficaram perfeitos. Foi muito atenciosa do início a entrega do projeto, receptiva às nossas solicitações de ajustes... Super indico! 😍',
  },
  {
    name: 'Isabela Guilherme Gonçalves',
    text: 'Maravilhosa, meus projetos ficaram perfeitos e práticos, sou apaixonada no trabalho, parabéns!',
  },
];

export function TestimonialsSection() {
  return (
    <section id="avaliacoes" className={styles.testimonials}>
      <div className={shared.frame}>
        <motion.div
          className={styles.reviewHeader}
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
        >
          <h2 className={`${shared.assetHeading} ${styles.reviewHeading}`}>
            <img src={headingReviews} alt="O que dizem sobre nós" />
          </h2>
          <p>Avaliações reais de famílias e profissionais que confiaram no nosso trabalho.</p>
        </motion.div>

        <motion.div
          className={styles.reviewGrid}
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.15 }}
        >
          {reviews.map((review, i) => (
            <motion.article
              className={styles.reviewCard}
              key={review.name}
              variants={cardVariant}
              custom={i}
            >
              <div className={styles.stars} aria-label="5 estrelas">
                ★★★★★
              </div>
              <p>"{review.text}"</p>
              <div className={styles.reviewAuthor}>
                <span>☆</span>
                <strong>{review.name}</strong>
                <small>Avaliação Google</small>
              </div>
            </motion.article>
          ))}
        </motion.div>

        <div className={styles.reviewCta}>
          <p>Foi nosso cliente? Compartilhe sua experiencia!</p>
          <a href={GOOGLE_REVIEW_URL} target="_blank" rel="noopener noreferrer">
            Deixar Avaliação no Google
          </a>
        </div>
      </div>
    </section>
  );
}
